import type { ReactElement } from 'react';

export function LandingNav(): ReactElement {
  return (
    <nav className="landing-nav">
      <div className="landing-nav-inner">
        <a href="#" className="landing-logo">
          <svg className="landing-logo-mark" viewBox="0 0 40 40" fill="none">
            <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="1.2" />
            <ellipse cx="20" cy="20" rx="18" ry="6" stroke="currentColor" strokeWidth="1.2" />
            <ellipse cx="20" cy="20" rx="6" ry="18" stroke="currentColor" strokeWidth="1.2" />
            <circle cx="20" cy="20" r="2.5" fill="currentColor" />
          </svg>
          <span className="landing-logo-text">
            gimbal<span className="landing-logo-dot">.cloud</span>
          </span>
        </a>

        <div className="landing-nav-links">
          <a href="#spaces">Spaces</a>
          <a href="#activity">Live</a>
          <a href="#usecases">Use cases</a>
          <a href="#integration">MCP</a>
          <a href="#pricing">Pricing</a>
          <span className="landing-status-pill">
            <span className="landing-dot live" />
            All systems nominal
          </span>
        </div>

        <div className="landing-nav-actions">
          <a href="/login" className="landing-btn-ghost">Sign in</a>
          <a href="/register" className="landing-btn-primary">
            Give my agent a world &rarr;
          </a>
        </div>
      </div>
    </nav>
  );
}
